<template>
  <b-modal
    ref="modal"
    title="Rename linked brief folder"
    centered
    @hide="closeHandler"
  >
    <p class="mb-2">
      This folder is linked to the brief
      <strong>{{ briefTitle }}</strong>.
      Rename the brief too?
    </p>
    <p class="text-muted small mb-0">
      Choosing &ldquo;Just the folder&rdquo; stops automatic syncing. The brief will get a new folder the next time assets are added.
    </p>

    <template #modal-footer>
      <b-button
        variant="outline-secondary"
        @click="$refs.modal.hide()"
      >
        Cancel
      </b-button>
      <b-button
        variant="outline-primary"
        @click="confirm('folder_only')"
      >
        Just the folder
      </b-button>
      <b-button
        variant="primary"
        @click="confirm('both')"
      >
        Rename both
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import mixinModal from './mixin';
import { createNamespacedHelpers } from 'vuex';
import { FILE_TYPE } from '@frontend/constants/file-image-types';

const { mapActions } = createNamespacedHelpers('fileBrowser');

export default {
  name: 'BriefFolderRenameModal',
  mixins: [mixinModal],
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    briefTitle() {
      return this.payload?.brief_title || this.payload?.name || '';
    },
  },
  methods: {
    ...mapActions(['editFile']),
    async confirm(action) {
      await this.editFile({
        id: this.payload.id,
        name: this.payload.name,
        item: this.payload.item || { type: FILE_TYPE.FOLDER },
        brief_rename_action: action,
      });
    },
  },
};
</script>
